import React, { useEffect, useState } from 'react';
import {
    Chip,
    Grid,
    Paper,
    TextField,
} from '@material-ui/core';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { 
    Switch as SwitchAntd, 
    Tooltip as TooltipAntd 
} from 'antd';
import { useAuth } from "../Auth";

const CambioIP = ()=>{
    const { authTokens, setRuta } = useAuth(); 
    const { enqueueSnackbar } = useSnackbar();
    const [ getZonas, setZonas ] = useState([]); 

    useEffect(()=>{
        (async ()=>{
            const fetchZonas = await fetch('/api/zonas');
            const JsonZonas  = await fetchZonas.json();
            setZonas( JsonZonas.filter(el=> el.Empresa === authTokens.Empresa));
            setRuta('/Conf/CambioIP');
        })()
    },[]); // eslint-disable-line react-hooks/exhaustive-deps


    return(
        <Grid container justifyContent='center' alignItems='center' style={{padding:10 }}>
            <Grid item lg={6} md={7} sm={10} xs={12}>
                <Paper elevation={2} style={{padding:10, minHeight:600, height:500, overflowY:'auto', overflowX:'hidden'}}>
                    <Grid container justifyContent='center' alignItems='center' spacing={3} style={{ minHeight:590, height:490 }}>
                        {
                            getZonas.map(el=> 
                                <ElementZ 
                                    data={ el } 
                                    enqueueSnackbar={ enqueueSnackbar }
                                />
                            )
                        }
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    )
};

const ElementZ = ({data, enqueueSnackbar})=>{
    const [ isChecked, setChecked ] = useState(data.isSecondary);

    const handleChangeIp = (checked)=>{
        if(data.IPSECONDARY){
            if(data.IPSECONDARY !== ''){
                fetch('/api/zonas/CambioIP',{
                    method:'PUT',
                    body: JSON.stringify({_id:data._id, isSecondary:checked}),
                    headers:{
                        'Content-Type': 'application/json'
                    }
                }) 
                .then(response=> response.json())
                .then(result =>{
                    if(result.message){
                        enqueueSnackbar(result.message, {variant:'success'});       
                        setChecked(checked); 
                    }else{
                        enqueueSnackbar(result.status, {variant:'error'});
                        setChecked(false);
                    }
                });
            }else{
                enqueueSnackbar('NO SE PUEDE REALIZAR EL CAMBIO', {variant:'error'});
                setChecked(false);
            }
        }else{
            enqueueSnackbar('NO SE PUEDE REALIZAR EL CAMBIO', {variant:'error'});
            setChecked(false);
        }
    }

    return(
        <Grid item xs={12}>
            <Paper variant='outlined' style={{padding:10, minHeight:100}}>
                <Grid container justifyContent='center' alignItems='center' spacing={2} >
                    <Grid item xs={12}>
                        <Chip color={isChecked ? 'secondary' : 'primary'} label={data.Zona} style={{fontWeight:'bolder'}}/>
                    </Grid>
                    <Grid item  md={5} xs={12}>
                        <TextField
                            label={'IP PRIMARIA'}
                            value={data.IP}
                            variant='outlined'
                            fullWidth
                        />
                    </Grid>
                    <Grid item md={2} xs={3}>
                        <TooltipAntd title="CAMBIAR IP" color='blue' >
                            <SwitchAntd 
                                checked={isChecked}
                                checkedChildren="ON" 
                                onChange={handleChangeIp}
                                unCheckedChildren="OFF"   />
                        </TooltipAntd>
                    </Grid>
                    <Grid item md={5} xs={9}>
                        <TextField
                            color='secondary'
                            label={'IP SECONDARY'}
                            value={data.IPSECONDARY}
                            variant='outlined'
                            fullWidth
                        />
                    </Grid>
                </Grid>
            </Paper>
        </Grid>
    )
};

const CambioIp = ()=>{
    return (
        <SnackbarProvider maxSnack={3} hideIconVariant={false} dense >
          <CambioIP />
        </SnackbarProvider>
    );
};

export default CambioIp;